import { cn } from "@/lib/utils";

export function NextIcon({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-2 w-[5px] text-white", className)}
      viewBox="0 0 5 8"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M.559 6.774l2.357-2.778L.559 1.22a.806.806 0 010-1.01.542.542 0 01.856 0l2.788 3.286c.237.28.237.73 0 1.01L1.415 7.79a.543.543 0 01-.856 0c-.231-.28-.237-.738 0-1.017z"
        fill="currentColor"
      />
    </svg>
  );
}

export function PrevIcon({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-2 w-[5px] text-white", className)}
      viewBox="0 0 5 8"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.203 6.774L1.846 3.996 4.203 1.22a.806.806 0 000-1.01.543.543 0 00-.856 0L.559 3.495a.806.806 0 000 1.01L3.347 7.79c.237.279.62.279.856 0 .231-.28.237-.738 0-1.017z"
        fill="currentColor"
      />
    </svg>
  );
}
